import { useMemo } from 'react'

import { useCampaignForm } from '../hooks/useCampaignForm'
import DebugModeToggle from './DebugModeToggle'
import HandleStrategies from './HandleStrategies'
import ObjectiveBased from './ObjectiveBased'
import StandardCampaignForm from './Standard'

const CampaignStrategy: React.FC = () => {
  const { selectedStategyCampaign } = useCampaignForm()

  const Component = useMemo(
    () =>
      selectedStategyCampaign === 'objective_based'
        ? ObjectiveBased
        : StandardCampaignForm,
    [selectedStategyCampaign]
  )

  return (
    <>
      {selectedStategyCampaign && <Component />}

      <HandleStrategies />

      <DebugModeToggle />
    </>
  )
}

export default CampaignStrategy
